// bnz-briefing.ts
import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum BNZBriefingEmployeeSignaturesKeys {
  employeeName = 'employeeName',
  employeeSignature = 'employeeSignature',
}

export enum BNZBriefingChecklistKeys {
  itemNumber = 'itemNumber',
  itemName = 'itemName',
  description = 'description',
  completed = 'completed',
}

export const BNZBriefingFileDataSchema = yup.object().shape({
  siteName: yup.string().nullable().optional(),
  submittedAt: yup.string().nullable().optional(),
  submittedBy: yup.string().nullable().optional(),
  submissionSignature: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
  checklist: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        completed: yup.string().nullable().optional(),
      }),
    )
    .required(),
  employeeSignatures: yup
    .array()
    .of(
      yup.object().shape({
        [BNZBriefingEmployeeSignaturesKeys.employeeName]: yup.string().nullable().optional(),
        [BNZBriefingEmployeeSignaturesKeys.employeeSignature]: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BNZBriefingFileData = yup.InferType<typeof BNZBriefingFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BNZBriefingFileData>

export const BNZBriefingFileMappings: RequiredFileData = {
  siteName: 'c95b7915-0692-427d-80c7-9358f534a58a',
  submittedAt: 'd2466f0e-8bea-4282-9d53-2c095e5df8c7',
  submittedBy: 'c4025eb6-760a-4398-94c8-193743b0a801',
  submissionSignature: '4d2fc19b-de9f-483f-84c2-d0da01a5f831',
  instructions: 'fd14bedc-8afb-4a70-9521-23f5f7014e4e',
  checklist: [
    {
      itemNumber: null,
      itemName: '8326c2d9-1c41-4acf-bb20-4daa52e7427a',
      description: '5a7b8d7e-6eeb-4b0d-8936-8db88e0bcc71',
      completed: '38fe0da8-1112-4e94-b30e-c28068323785',
    },
  ],
  employeeSignatures: [
    {
      employeeName: '70fa0b91-5050-40d7-8938-a2b132a5acd3',
      employeeSignature: '3c7b3736-705f-491e-a68b-c91a2a9aeb12',
    },
  ],
}
